/**
 * Workspace / perfil — re-exporta de `@imobdesk/contracts`.
 */
import { workspace } from '@imobdesk/contracts'

export const profileResponseSchema = workspace.profileResponseSchema
export type ProfileResponse = workspace.ProfileResponse

export const userProfileSchema = workspace.userProfileSchema
export type UserProfile = workspace.UserProfile
